import { Button, Menu, Typography } from "@material-tailwind/react";
import { HiOutlineChevronLeft, HiOutlineChevronRight, HiOutlineDotsHorizontal } from "react-icons/hi";
import Pagination from 'rc-pagination';

const PaginationCustom = ({
  currentPage,
  pageSize,
  totalItems,
  onPageChange,
  onSizeChange,
  className = "",
  showPageSize = true,
  loading = false,
}) => {
  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math.min(currentPage * pageSize, totalItems);

  return (
    <div className="flex items-center justify-between mb-4">
      <Typography className="font-normal text-blue-gray-400">
        {loading ? (
          <div className="w-48 h-4 bg-gray-200 rounded animate-pulse"></div>
        ) : totalItems > 0 ? (
          `Showing ${startItem} - ${endItem} of ${totalItems} items`
        ) : null}
      </Typography>
      <Pagination
        current={currentPage}
        pageSize={pageSize}
        onChange={onPageChange}
        className={`flex items-center gap-3 ${className}`}
        total={totalItems}
        showPrevNext={true}
        showLessItems={true}
        showSizeChanger={showPageSize}
        onShowSizeChange={onSizeChange}
        sizeChangerRender={(props) => {
          return (
            <div>
              <Menu>
                <Menu.Trigger as={Button} className="flex items-center gap-2 px-4" variant="outline" color="secondary">
                  Page Size: {pageSize}
                </Menu.Trigger>
                <Menu.Content>
                  <Menu.Item onClick={() => onSizeChange(10)}>10</Menu.Item>
                  <Menu.Item onClick={() => onSizeChange(20)}>20</Menu.Item>
                  <Menu.Item onClick={() => onSizeChange(50)}>50</Menu.Item>
                </Menu.Content>
              </Menu> 
            </div>
          )
        }}
        prevIcon={<HiOutlineChevronLeft className="w-4 h-4" />}
        nextIcon={<HiOutlineChevronRight className="w-4 h-4" />}
        jumpPrevIcon={<HiOutlineDotsHorizontal className="w-4 h-4" />}
        jumpNextIcon={<HiOutlineDotsHorizontal className="w-4 h-4" />}
        itemRender={(_page, type, element) => {
          if (type === "page") {
            return (
              <Button
                className={`w-8 h-8 flex items-center justify-center p-0 shadow-none text-primary rounded-md ${currentPage === _page ? "bg-primary text-white" : "bg-blue-gray-50"}`}
              >
                {element}
              </Button>
            );
          }
          return element;
        }}
      />
    </div>
  );
};

export default PaginationCustom;
